import { render, staticRenderFns } from "./StudentRelationForm.vue?vue&type=template&id=72301cda"
import script from "./StudentRelationForm.vue?vue&type=script&lang=js"
export * from "./StudentRelationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72301cda')) {
      api.createRecord('72301cda', component.options)
    } else {
      api.reload('72301cda', component.options)
    }
    module.hot.accept("./StudentRelationForm.vue?vue&type=template&id=72301cda", function () {
      api.rerender('72301cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentRelation/modules/StudentRelationForm.vue"
export default component.exports